import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-21">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0" data-id="element-22">
        <img src="https://cdn.magicpatterns.com/uploads/wwZvKGFRuCySqMA21pqESR/1N0A6481.jpg" alt="22A Clendon Court, Toorak street view" className="h-full w-full object-cover" data-id="element-23" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/70" data-id="element-24" />
      </div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-end pb-24 md:pb-32" data-id="element-25">
        <div className="max-w-4xl" data-id="element-26">
          <h1 className="text-7xl md:text-9xl lg:text-[10rem] text-white font-semibold mb-3 leading-none" style={{
          textShadow: '0 2px 40px rgba(0,0,0,0.8), 0 1px 6px rgba(0,0,0,0.95)'
        }} data-id="element-27">
            Clendon Court
          </h1>

          <p className="text-xl md:text-2xl text-[#C9B99A] tracking-[0.25em] uppercase font-light mb-8" style={{
          textShadow: '0 1px 12px rgba(0,0,0,0.9)'
        }} data-id="element-28">
            22A Clendon Road, Toorak
          </p>

          <div className="h-px w-32 bg-[#C9B99A] mb-8" data-id="element-29" />

          <p className="text-lg md:text-xl text-white/90 font-light max-w-xl leading-relaxed" style={{
          textShadow: '0 1px 12px rgba(0,0,0,0.8)'
        }} data-id="element-30">
            A rare opportunity to acquire a significant landholding opposite
            Loreto Mandeville Hall.
          </p>
        </div>
      </div>
      {/* Logo - Top Left */}
      <div className="absolute top-6 left-6 z-10" data-id="element-31">
        <img src="https://cdn.magicpatterns.com/uploads/pv4AMcRfKpvr4ZntCb24Rj/Stonebridge_logo_master_reversed_1.0.png" alt="Stonebridge Property Group" className="h-10 md:h-12 w-auto" data-id="element-32" />
      </div>
    </section>;
}